import {
    PageHeader,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { assertHasAuthorization } from '@frontend/utils';
import type { IPatient } from '../../../../common/interfaces/patient';
import type { IInsuranceHistory } from '../../interfaces/insuranceHistory';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { NullableStringBirthDate } from '../../elements/NullableStringBirthDate';

interface IPatientDataProps {
    patient: IPatient;
}

export function PatientInsuranceHistory(props: IPatientDataProps) {
    const [insuranceHistories, setInsuranceHistories] = useState<IInsuranceHistory[]>([]);

    assertHasAuthorization(ManagerAuthorization.patientInsurance);

    useEffect(() => {
        loadInsuranceHistory();
    }, []);

    return (
        <>
            <PageHeader title={translateKey('insuranceHistory.insuranceHistory')} />
            <TableContainer>
                <Table spacing="medium">
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translateKey('uzovi.code')}</TableHeader>
                            <TableHeader>{translateKey('common.name')}</TableHeader>
                            <TableHeader>{translateKey('insurers.insurer')}</TableHeader>
                            <TableHeader>{translateKey('insuranceHistory.insurancePolicyNumber')}</TableHeader>
                            <TableHeader>{translateKey('insuranceHistory.startDate')}</TableHeader>
                            <TableHeader>{translateKey('insuranceHistory.endDate')}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {insuranceHistories.map((item, i) => (
                            <TableRow key={i}>
                                <TableCell>{item.uzovi.code}</TableCell>
                                <TableCell>{item.uzovi.name}</TableCell>
                                <TableCell>{item.insurer?.name}</TableCell>
                                <TableCell>{item.insurancePolicyNumber}</TableCell>
                                <TableCell>
                                    <NullableStringBirthDate value={item.startDate} />
                                </TableCell>
                                <TableCell>
                                    <NullableStringBirthDate value={item.endDate} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );

    async function loadInsuranceHistory() {
        const url = `/api/patients/${props.patient.id}/insuranceHistory`;
        const results = await fetchJson(url, 'GET');
        setInsuranceHistories(results.json.items);
    }
}
